import { render, staticRenderFns } from "./DescriptionBox.vue?vue&type=template&id=4c06b9fc&scoped=true"
import script from "./DescriptionBox.vue?vue&type=script&lang=js"
export * from "./DescriptionBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06b9fc",
  null
  
)

export default component.exports